export enum QuickFiltersEnum {
  All = "all",
  Unpaid = "unpaid",
}
